/** secrets screen strings (EN source of truth + VI); spread into the main dictionaries */

export const secretsEn = {
  'secrets.title': 'Secrets',
  'secrets.subtitle': 'Encrypted values for your apps and agents, with versions, access grants and an audit trail.',
  'secrets.version': 'v{version}',

  'secrets.kind.secret': 'Secret',
  'secrets.kind.value': 'Plain value',

  'secrets.time.never': 'Never',
  'secrets.time.unknown': 'Unknown',

  'secrets.field.description': 'Description (optional)',
  'secrets.field.reasonOptional': 'Reason (optional)',

  'secrets.filters.label': 'Filters',
  'secrets.filters.environment': 'Environment',
  'secrets.filters.path': 'Path',
  'secrets.filters.search': 'Search',
  'secrets.filters.searchPlaceholder': 'Search keys',
  'secrets.filters.count': '{count} entries',

  'secrets.list.label': 'Secrets',
  'secrets.list.empty': 'No secrets match these filters.',
  'secrets.list.loadError': 'Could not load secrets. {message}',
  'secrets.list.masked': 'Hidden',
  'secrets.list.updated': 'Updated {date}',
  'secrets.list.disable': 'Disable secret',
  'secrets.list.disableNamed': 'Disable {key}',

  'secrets.create.open': 'New secret',
  'secrets.create.title': 'New secret',
  'secrets.create.location': 'Saved in environment "{environment}" at path {path}. Change these in the filters.',
  'secrets.create.key': 'Key',
  'secrets.create.keyHint': 'Letters, digits and underscores; must not start with a digit.',
  'secrets.create.value': 'Value',
  'secrets.create.kind': 'Type',
  'secrets.create.kindHint': 'Secrets stay hidden until revealed. Plain values are shown in the list.',
  'secrets.create.submit': 'Create secret',
  'secrets.create.submitting': 'Creating…',

  'secrets.detail.empty': 'Select a secret to add a version, reveal it, manage access and see its audit trail.',
  'secrets.detail.label': 'Details for {key}',

  'secrets.update.title': 'New version',
  'secrets.update.value': 'New value',
  'secrets.update.valueHint': 'Leave empty to keep the current value and only change the type or description.',
  'secrets.update.submit': 'Save as v{version}',
  'secrets.update.submitting': 'Saving…',

  'secrets.reveal.title': 'Reveal value',
  'secrets.reveal.reason': 'Reason',
  'secrets.reveal.hint': 'Every reveal is recorded in the audit trail.',
  'secrets.reveal.reasonRequired': 'Enter a reason before revealing the value.',
  'secrets.reveal.submit': 'Reveal',
  'secrets.reveal.submitting': 'Revealing…',
  'secrets.reveal.shown': 'Value of v{version}. Hide it when you are done.',
  'secrets.reveal.valueLabel': 'Value of {key}',
  'secrets.reveal.hide': 'Hide value',
  'secrets.reveal.pendingApproval': 'This reveal is waiting for an admin to approve it.',

  'secrets.versions.title': 'Versions',
  'secrets.versions.empty': 'No versions yet.',
  'secrets.versions.current': 'Current',
  'secrets.versions.rollback': 'Roll back',
  'secrets.versions.rollbackTo': 'Roll back to v{version}',

  'secrets.grants.title': 'Access grants',
  'secrets.grants.empty': 'No active grants cover this secret.',
  'secrets.grants.listLabel': 'Active grants',
  'secrets.grants.expires': 'Expires: {date}',
  'secrets.grants.revoke': 'Revoke grant',
  'secrets.grants.revokeNamed': 'Revoke grant for {name}',
  'secrets.grants.noPermissions': 'no permissions',
  'secrets.grants.newTitle': 'Grant access',
  'secrets.grants.targetType': 'Grant to',
  'secrets.grants.target.apiKey': 'API key',
  'secrets.grants.target.user': 'User',
  'secrets.grants.target.agent': 'Agent',
  'secrets.grants.target.skill': 'Skill',
  'secrets.grants.targetId': 'Target ID',
  'secrets.grants.displayName': 'Display name',
  'secrets.grants.keyPattern': 'Key pattern',
  'secrets.grants.ttlDays': 'Expires after (days, optional)',
  'secrets.grants.permissions': 'Permissions',
  'secrets.grants.selfWarning':
    'This grants access to yourself. In a workspace with another admin, that admin must create it. When you are the only admin, a reason of at least {count} characters is required and a warning email is sent to you.',
  'secrets.grants.reasonRequired': 'Reason (required)',
  'secrets.grants.reasonHint': 'At least {count} characters, not counting spaces.',
  'secrets.grants.submit': 'Create grant',
  'secrets.grants.submitting': 'Creating…',

  'secrets.audit.title': 'Audit trail',
  'secrets.audit.empty': 'No audit events for this secret yet.',
  'secrets.audit.unknownEvent': 'Event',

  'secrets.danger.title': 'Disable or destroy',
  'secrets.danger.hint': 'Disabling hides the secret from lists and lookups. Destroying erases every version for good.',

  'secrets.confirm.disableTitle': 'Disable {key}?',
  'secrets.confirm.disableBody': 'The secret disappears from lists and lookups. Its versions are kept.',
  'secrets.confirm.disable': 'Disable',
  'secrets.confirm.destroyTitle': 'Destroy {key}?',
  'secrets.confirm.destroyBody': 'The current value and every earlier version are erased. This cannot be undone.',
  'secrets.confirm.destroy': 'Destroy',
  'secrets.confirm.revokeTitle': 'Revoke the grant for {name}?',
  'secrets.confirm.revokeBody': 'The target loses this access immediately.',
  'secrets.confirm.revoke': 'Revoke',
  'secrets.confirm.rollbackTitle': 'Roll back to v{version}?',
  'secrets.confirm.rollbackBody': 'A new version is created with the value of the selected version.',
  'secrets.confirm.rollback': 'Roll back',
  'secrets.confirm.working': 'Working…',

  'secrets.toast.created': '{key} created',
  'secrets.toast.updated': 'Saved as v{version}',
  'secrets.toast.updateFailed': 'Could not save the new version',
  'secrets.toast.grantCreated': 'Grant created',
  'secrets.toast.disabled': 'Secret disabled',
  'secrets.toast.destroyed': 'Secret destroyed',
  'secrets.toast.grantRevoked': 'Grant revoked',
  'secrets.toast.rolledBack': 'Rolled back to v{version}',
  'secrets.toast.actionFailed': 'The action failed',

  'secrets.import.title': 'Import .env',
  'secrets.import.hint': 'Imports into environment "{environment}" at path {path}.',
  'secrets.import.content': '.env content',
  'secrets.import.overwrite': 'Overwrite existing keys',
  'secrets.import.submit': 'Import',
  'secrets.import.submitting': 'Importing…',
  'secrets.import.done': 'Import finished: {created} created, {updated} updated, {skipped} skipped',
  'secrets.import.failed': 'Import failed',
  'secrets.import.confirmTitle': 'Overwrite existing secrets?',
  'secrets.import.confirmBody': 'Keys that already exist in this environment and path get a new version with the imported value.',
  'secrets.import.confirm': 'Import and overwrite',

  'secrets.export.title': 'Export',
  'secrets.export.hint': 'Exports the current environment and path as .env text. Values stay hidden unless you include them.',
  'secrets.export.reveal': 'Include raw values',
  'secrets.export.reasonRequiredLabel': 'Reason (required for raw values)',
  'secrets.export.reasonRequired': 'Enter a reason to export raw values.',
  'secrets.export.submit': 'Export',
  'secrets.export.submitting': 'Exporting…',
  'secrets.export.output': 'Exported .env',
  'secrets.export.clear': 'Clear output',

  'secrets.requests.title': 'Agent reveal requests',
  'secrets.requests.hint': 'An API key asked to see a secret value. Approving lets it read the value once within 15 minutes.',
  'secrets.requests.adminOnly': 'Only workspace admins can approve reveal requests.',
  'secrets.requests.loadError': 'Could not load reveal requests. {message}',
  'secrets.requests.notPending': 'This request is no longer waiting: it was already decided or has expired.',
  'secrets.requests.apiKey': 'API key: {name}',
  'secrets.requests.reason': 'Reason: {reason}',
  'secrets.requests.timing': 'Requested {requested} · expires {expires}',
  'secrets.requests.approve': 'Approve',
  'secrets.requests.approveNamed': 'Approve reveal of {key}',
  'secrets.requests.deny': 'Deny',
  'secrets.requests.denyNamed': 'Deny reveal of {key}',
  'secrets.requests.approved': 'Approved: the agent can read the value once within 15 minutes',
  'secrets.requests.denied': 'Reveal request denied',
  'secrets.requests.decideFailed': 'Could not record the decision',

  'secrets.error.rateLimited': 'Too many reveals, injects or exports in the last minute. Wait a minute and try again.',
  'secrets.error.forbidden': 'You do not have permission to do this.',
  'secrets.error.grantRequired': 'You need a grant that covers this secret. Create one under Access grants for this secret.',
  'secrets.error.tooManyRequests': 'Too many requests right now. Wait a moment and try again.',
  'secrets.error.agentFlagRequired': 'This API key needs the matching agent secret permission.',
  'secrets.error.selfGrantDenied': 'You cannot grant access to yourself in a workspace with another admin. Ask that admin to create the grant.',
  'secrets.error.selfGrantReason': 'Granting access to yourself needs a reason of at least {count} characters. A warning email is sent to you.',
  'secrets.error.alreadyExists': 'A secret with this key already exists in this environment and path.',
  'secrets.error.versionConflict': 'This secret changed in the meantime. Reload it and try again.',
  'secrets.error.notFound': 'The secret was not found. It may have been disabled or destroyed.',
  'secrets.error.versionNotFound': 'That version no longer exists.',
  'secrets.error.reasonRequired': 'A reason is required for this action.',
  'secrets.error.requestClosed': 'This reveal request is no longer waiting for a decision.',
  'secrets.error.encryptionUnavailable': 'Secret encryption is not configured correctly on the server. Contact your administrator.',
  'secrets.error.validation': 'Some input is not valid ({detail}).',
  'secrets.error.signedOut': 'Your session has ended. Sign in again.',
  'secrets.error.server': 'The server could not complete the request (error {status}). Try again.',
  'secrets.error.network': 'Could not reach the server. Check your connection and try again.',
  // /secrets now explains the move to AgentKit's `ak secrets` (the old dashboard is kept in code, not routed)
  'secrets.moved.title': 'Secrets moved to ak secrets',
  'secrets.moved.body': 'AgentWiki no longer manages secrets in the web app. Keep them in AgentKit\'s ak secrets instead: a local-first vault, encrypted end to end on your own devices, so no server holds the keys.',
  'secrets.moved.sync': 'Working on several devices? ak secrets sync keeps the encrypted vault in step between them (preview).',
  'secrets.moved.export': 'Secrets you already stored here stay readable through the API and CLI, so you can export them and import them into ak:',
  'secrets.moved.docs': 'How to move your secrets',
} satisfies Record<string, string>

export const secretsVi: Record<keyof typeof secretsEn, string> = {
  'secrets.title': 'Bí mật',
  'secrets.subtitle': 'Giá trị được mã hóa cho ứng dụng và agent, có phiên bản, quyền truy cập và nhật ký kiểm tra.',
  'secrets.version': 'v{version}',

  'secrets.kind.secret': 'Bí mật',
  'secrets.kind.value': 'Giá trị thường',

  'secrets.time.never': 'Không bao giờ',
  'secrets.time.unknown': 'Không rõ',

  'secrets.field.description': 'Mô tả (không bắt buộc)',
  'secrets.field.reasonOptional': 'Lý do (không bắt buộc)',

  'secrets.filters.label': 'Bộ lọc',
  'secrets.filters.environment': 'Môi trường',
  'secrets.filters.path': 'Đường dẫn',
  'secrets.filters.search': 'Tìm kiếm',
  'secrets.filters.searchPlaceholder': 'Tìm theo khóa',
  'secrets.filters.count': '{count} mục',

  'secrets.list.label': 'Danh sách bí mật',
  'secrets.list.empty': 'Không có bí mật nào khớp với bộ lọc.',
  'secrets.list.loadError': 'Không tải được danh sách bí mật. {message}',
  'secrets.list.masked': 'Đã ẩn',
  'secrets.list.updated': 'Cập nhật {date}',
  'secrets.list.disable': 'Vô hiệu hóa bí mật',
  'secrets.list.disableNamed': 'Vô hiệu hóa {key}',

  'secrets.create.open': 'Bí mật mới',
  'secrets.create.title': 'Bí mật mới',
  'secrets.create.location': 'Lưu vào môi trường "{environment}" tại đường dẫn {path}. Đổi hai giá trị này ở bộ lọc.',
  'secrets.create.key': 'Khóa',
  'secrets.create.keyHint': 'Chữ cái, chữ số và dấu gạch dưới; không bắt đầu bằng chữ số.',
  'secrets.create.value': 'Giá trị',
  'secrets.create.kind': 'Loại',
  'secrets.create.kindHint': 'Bí mật luôn bị ẩn cho đến khi được hiện. Giá trị thường hiển thị ngay trong danh sách.',
  'secrets.create.submit': 'Tạo bí mật',
  'secrets.create.submitting': 'Đang tạo…',

  'secrets.detail.empty': 'Chọn một bí mật để thêm phiên bản, xem giá trị, quản lý quyền truy cập và xem nhật ký.',
  'secrets.detail.label': 'Chi tiết của {key}',

  'secrets.update.title': 'Phiên bản mới',
  'secrets.update.value': 'Giá trị mới',
  'secrets.update.valueHint': 'Để trống nếu muốn giữ giá trị hiện tại và chỉ đổi loại hoặc mô tả.',
  'secrets.update.submit': 'Lưu thành v{version}',
  'secrets.update.submitting': 'Đang lưu…',

  'secrets.reveal.title': 'Xem giá trị',
  'secrets.reveal.reason': 'Lý do',
  'secrets.reveal.hint': 'Mọi lần xem giá trị đều được ghi vào nhật ký kiểm tra.',
  'secrets.reveal.reasonRequired': 'Hãy nhập lý do trước khi xem giá trị.',
  'secrets.reveal.submit': 'Xem giá trị',
  'secrets.reveal.submitting': 'Đang lấy giá trị…',
  'secrets.reveal.shown': 'Giá trị của v{version}. Hãy ẩn đi khi dùng xong.',
  'secrets.reveal.valueLabel': 'Giá trị của {key}',
  'secrets.reveal.hide': 'Ẩn giá trị',
  'secrets.reveal.pendingApproval': 'Yêu cầu xem giá trị đang chờ quản trị viên phê duyệt.',

  'secrets.versions.title': 'Các phiên bản',
  'secrets.versions.empty': 'Chưa có phiên bản nào.',
  'secrets.versions.current': 'Hiện tại',
  'secrets.versions.rollback': 'Khôi phục',
  'secrets.versions.rollbackTo': 'Khôi phục về v{version}',

  'secrets.grants.title': 'Quyền truy cập',
  'secrets.grants.empty': 'Chưa có quyền truy cập nào đang hiệu lực cho bí mật này.',
  'secrets.grants.listLabel': 'Quyền truy cập đang hiệu lực',
  'secrets.grants.expires': 'Hết hạn: {date}',
  'secrets.grants.revoke': 'Thu hồi quyền',
  'secrets.grants.revokeNamed': 'Thu hồi quyền của {name}',
  'secrets.grants.noPermissions': 'không có quyền nào',
  'secrets.grants.newTitle': 'Cấp quyền truy cập',
  'secrets.grants.targetType': 'Cấp cho',
  'secrets.grants.target.apiKey': 'Khóa API',
  'secrets.grants.target.user': 'Người dùng',
  'secrets.grants.target.agent': 'Agent',
  'secrets.grants.target.skill': 'Kỹ năng',
  'secrets.grants.targetId': 'ID đối tượng',
  'secrets.grants.displayName': 'Tên hiển thị',
  'secrets.grants.keyPattern': 'Mẫu khóa',
  'secrets.grants.ttlDays': 'Hết hạn sau (số ngày, không bắt buộc)',
  'secrets.grants.permissions': 'Quyền',
  'secrets.grants.selfWarning':
    'Bạn đang tự cấp quyền cho chính mình. Nếu không gian làm việc có quản trị viên khác, người đó phải tạo quyền này. Khi bạn là quản trị viên duy nhất, cần nhập lý do dài ít nhất {count} ký tự và bạn sẽ nhận được email cảnh báo.',
  'secrets.grants.reasonRequired': 'Lý do (bắt buộc)',
  'secrets.grants.reasonHint': 'Ít nhất {count} ký tự, không tính khoảng trắng.',
  'secrets.grants.submit': 'Cấp quyền',
  'secrets.grants.submitting': 'Đang cấp quyền…',

  'secrets.audit.title': 'Nhật ký kiểm tra',
  'secrets.audit.empty': 'Bí mật này chưa có sự kiện nào trong nhật ký.',
  'secrets.audit.unknownEvent': 'Sự kiện',

  'secrets.danger.title': 'Vô hiệu hóa hoặc hủy',
  'secrets.danger.hint': 'Vô hiệu hóa sẽ ẩn bí mật khỏi danh sách và tra cứu. Hủy sẽ xóa vĩnh viễn mọi phiên bản.',

  'secrets.confirm.disableTitle': 'Vô hiệu hóa {key}?',
  'secrets.confirm.disableBody': 'Bí mật sẽ biến mất khỏi danh sách và tra cứu. Các phiên bản vẫn được giữ lại.',
  'secrets.confirm.disable': 'Vô hiệu hóa',
  'secrets.confirm.destroyTitle': 'Hủy {key}?',
  'secrets.confirm.destroyBody': 'Giá trị hiện tại và mọi phiên bản trước đó sẽ bị xóa. Không thể hoàn tác.',
  'secrets.confirm.destroy': 'Hủy vĩnh viễn',
  'secrets.confirm.revokeTitle': 'Thu hồi quyền của {name}?',
  'secrets.confirm.revokeBody': 'Đối tượng này sẽ mất quyền truy cập ngay lập tức.',
  'secrets.confirm.revoke': 'Thu hồi',
  'secrets.confirm.rollbackTitle': 'Khôi phục về v{version}?',
  'secrets.confirm.rollbackBody': 'Một phiên bản mới sẽ được tạo với giá trị của phiên bản đã chọn.',
  'secrets.confirm.rollback': 'Khôi phục',
  'secrets.confirm.working': 'Đang xử lý…',

  'secrets.toast.created': 'Đã tạo {key}',
  'secrets.toast.updated': 'Đã lưu thành v{version}',
  'secrets.toast.updateFailed': 'Không lưu được phiên bản mới',
  'secrets.toast.grantCreated': 'Đã cấp quyền',
  'secrets.toast.disabled': 'Đã vô hiệu hóa bí mật',
  'secrets.toast.destroyed': 'Đã hủy bí mật',
  'secrets.toast.grantRevoked': 'Đã thu hồi quyền',
  'secrets.toast.rolledBack': 'Đã khôi phục về v{version}',
  'secrets.toast.actionFailed': 'Thao tác không thành công',

  'secrets.import.title': 'Nhập từ .env',
  'secrets.import.hint': 'Nhập vào môi trường "{environment}" tại đường dẫn {path}.',
  'secrets.import.content': 'Nội dung .env',
  'secrets.import.overwrite': 'Ghi đè các khóa đã có',
  'secrets.import.submit': 'Nhập',
  'secrets.import.submitting': 'Đang nhập…',
  'secrets.import.done': 'Đã nhập xong: tạo mới {created}, cập nhật {updated}, bỏ qua {skipped}',
  'secrets.import.failed': 'Nhập không thành công',
  'secrets.import.confirmTitle': 'Ghi đè các bí mật đã có?',
  'secrets.import.confirmBody': 'Những khóa đã tồn tại trong môi trường và đường dẫn này sẽ có phiên bản mới với giá trị được nhập.',
  'secrets.import.confirm': 'Nhập và ghi đè',

  'secrets.export.title': 'Xuất',
  'secrets.export.hint': 'Xuất môi trường và đường dẫn hiện tại dưới dạng văn bản .env. Giá trị vẫn bị ẩn trừ khi bạn chọn đưa vào.',
  'secrets.export.reveal': 'Kèm giá trị gốc',
  'secrets.export.reasonRequiredLabel': 'Lý do (bắt buộc khi kèm giá trị gốc)',
  'secrets.export.reasonRequired': 'Hãy nhập lý do để xuất giá trị gốc.',
  'secrets.export.submit': 'Xuất',
  'secrets.export.submitting': 'Đang xuất…',
  'secrets.export.output': 'Nội dung .env đã xuất',
  'secrets.export.clear': 'Xóa kết quả',

  'secrets.requests.title': 'Yêu cầu xem giá trị từ agent',
  'secrets.requests.hint': 'Một khóa API muốn xem giá trị bí mật. Nếu phê duyệt, khóa đó được đọc giá trị một lần trong vòng 15 phút.',
  'secrets.requests.adminOnly': 'Chỉ quản trị viên của không gian làm việc mới phê duyệt được yêu cầu xem giá trị.',
  'secrets.requests.loadError': 'Không tải được các yêu cầu xem giá trị. {message}',
  'secrets.requests.notPending': 'Yêu cầu này không còn chờ xử lý: đã được quyết định hoặc đã hết hạn.',
  'secrets.requests.apiKey': 'Khóa API: {name}',
  'secrets.requests.reason': 'Lý do: {reason}',
  'secrets.requests.timing': 'Yêu cầu lúc {requested} · hết hạn {expires}',
  'secrets.requests.approve': 'Phê duyệt',
  'secrets.requests.approveNamed': 'Phê duyệt xem giá trị {key}',
  'secrets.requests.deny': 'Từ chối',
  'secrets.requests.denyNamed': 'Từ chối xem giá trị {key}',
  'secrets.requests.approved': 'Đã phê duyệt: agent được đọc giá trị một lần trong vòng 15 phút',
  'secrets.requests.denied': 'Đã từ chối yêu cầu xem giá trị',
  'secrets.requests.decideFailed': 'Không ghi nhận được quyết định',

  'secrets.error.rateLimited': 'Có quá nhiều lượt xem, chèn hoặc xuất giá trị trong một phút qua. Hãy đợi một phút rồi thử lại.',
  'secrets.error.forbidden': 'Bạn không có quyền thực hiện thao tác này.',
  'secrets.error.grantRequired': 'Bạn cần một quyền truy cập áp dụng cho bí mật này. Hãy tạo ở mục Quyền truy cập của bí mật này.',
  'secrets.error.tooManyRequests': 'Hiện có quá nhiều yêu cầu. Hãy đợi một lát rồi thử lại.',
  'secrets.error.agentFlagRequired': 'Khóa API này cần quyền bí mật dành cho agent tương ứng.',
  'secrets.error.selfGrantDenied': 'Bạn không thể tự cấp quyền khi không gian làm việc còn quản trị viên khác. Hãy nhờ người đó tạo quyền này.',
  'secrets.error.selfGrantReason': 'Tự cấp quyền cho chính mình cần lý do dài ít nhất {count} ký tự. Bạn sẽ nhận được email cảnh báo.',
  'secrets.error.alreadyExists': 'Đã có bí mật với khóa này trong môi trường và đường dẫn này.',
  'secrets.error.versionConflict': 'Bí mật vừa được thay đổi ở nơi khác. Hãy tải lại rồi thử lại.',
  'secrets.error.notFound': 'Không tìm thấy bí mật. Có thể nó đã bị vô hiệu hóa hoặc bị hủy.',
  'secrets.error.versionNotFound': 'Phiên bản đó không còn tồn tại.',
  'secrets.error.reasonRequired': 'Thao tác này cần có lý do.',
  'secrets.error.requestClosed': 'Yêu cầu xem giá trị này không còn chờ quyết định.',
  'secrets.error.encryptionUnavailable': 'Máy chủ chưa cấu hình đúng việc mã hóa bí mật. Hãy liên hệ quản trị viên.',
  'secrets.error.validation': 'Dữ liệu nhập chưa hợp lệ ({detail}).',
  'secrets.error.signedOut': 'Phiên đăng nhập đã hết. Hãy đăng nhập lại.',
  'secrets.error.server': 'Máy chủ không hoàn tất được yêu cầu (lỗi {status}). Hãy thử lại.',
  'secrets.error.network': 'Không kết nối được tới máy chủ. Hãy kiểm tra kết nối rồi thử lại.',
  'secrets.moved.title': 'Bí mật đã chuyển sang ak secrets',
  'secrets.moved.body': 'AgentWiki không còn quản lý bí mật trên ứng dụng web. Hãy lưu chúng bằng ak secrets của AgentKit: kho bí mật nằm ngay trên máy của bạn, mã hóa đầu cuối, nên không máy chủ nào giữ khóa giải mã.',
  'secrets.moved.sync': 'Dùng nhiều máy? ak secrets sync đồng bộ kho đã mã hóa giữa các máy (bản xem trước).',
  'secrets.moved.export': 'Các bí mật bạn đã lưu ở đây vẫn đọc được qua API và CLI, nên bạn có thể xuất ra rồi nhập vào ak:',
  'secrets.moved.docs': 'Hướng dẫn chuyển bí mật',
}
